import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

function Services() {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <h1>Our Story</h1>
          <p className="subtitle">A Decade of Excellence in Waste Management</p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="company-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content" style={{ fontSize: '1.25rem' }}>
              <h2>Our Story</h2>
              <p>
                All Star Logistics Partners has been providing top-notch dumpster rental services for over a decade.
                We pride ourselves on reliability, exceptional customer service, and a commitment to meeting
                our clients' needs throughout Alabama.
              </p>
              <p>
                Our team of experienced professionals understands the importance of timely service and efficient
                waste management solutions for both residential and commercial projects.
              </p>
            </div>
            <div className="overview-stats">
              <div className="stat-card">
                <h3>10+</h3>
                <p>Years of Experience</p>
              </div>
              <div className="stat-card">
                <h3>1000+</h3>
                <p>Completed Orders</p>
              </div>
              <div className="stat-card">
                <h3>24/7</h3>
                <p>Customer Support</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Experience our exceptional service today.</p>
          <Link to="/booking" className="cta-button">Get Your Quote</Link>
        </div>
      </section>
    </div>
  );
}

export default Services;
